export default {"src":"/_next/static/media/tooltip-questionmark.1d97c4ec.svg","height":24,"width":16};